import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { UserService } from "@/services/admin/UserService"
import { MeterpointService } from "@/services/MeterpointService"

export const getRenewalsForUser = (userId: number) => {
  const queries = new QueryAggregator()
  const userRenewalsQuery = UserService.getRenewalsByUserId(userId)
  queries.add(userRenewalsQuery)

  const data = userRenewalsQuery.data.map((renewal) => {
    const meterpointsQuery = MeterpointService.getMeterpointsIdentifiersByIds(
      renewal.meterpointIds,
    )
    queries.add(meterpointsQuery)

    return {
      ...renewal,
      meterpointIdentifiers: meterpointsQuery.data,
    }
  })

  return queries.setData(data).getAggregate()
}
